
<!DOCTYPE html>
<!--
This is a starter template page. Use this page to start your new project from
scratch. This page gets rid of all links and provides the needed markup only.
-->



<html lang="en">

<app-header-ecomerce>

  <style>

    .center {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height:200px;
        width: 600px;
    }
    .centerdiv {
      margin-left: auto;
      margin-right: auto;
      
      text-align: center;
      background-color: black;
       
    }.backgroundDiv{
    text-align: center;
  opacity: 0.9;
  }.IconoWhatsApp{
  height: 0px;
}
img.whatsapp {
  position: fixed;
  width: 40px;
  bottom: 65px;
  right: 42px;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  display: none;
}
#appear.active{
  display:inline;
}
  
    </style>

</app-header-ecomerce>




<div class="wrapper">
 
  <!-- Navbar -->
 
  <nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
    <!-- Left navbar links -->
   

    <!-- Right navbar links -->
    <ul class="navbar-nav lg-auto"  >
     
        <li class="nav-item" *ngIf="ocultarCarrito == false" >
          <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
            <i class="fas fa-bars" style="font-size: 34px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
          </a>
        </li>
 
      

      <!-- Navbar Search -->
      <li class="nav-item">
        <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
          <i class="fas fa-search"style="font-size: 32px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
        </a>
        <div class="navbar-search-block" >
          <form class="form-inline"  [formGroup]="formBuscar" >
            <div class="input-group input-group-sm" >
              <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: 20pt;height: 48px;border: 2px solid #0A0A0A; color: #0b0b0b;font-weight: bold;background-color: #FFFFFF;;height: 52px;" formControlName="txtBuscar" (keyup.enter)="OnBuscarAll()" >
              <div class="input-group-append">
                <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()"   style="border: 2px solid #424949;"  >
                  <i class="fas fa-search" style="font-size: 36px;"></i>
                </button>
                <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                  <i class="fas fa-times" style="font-size: 36px;"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>

    

    </ul>
    
   
    
    <ul    class="navbar-nav ml-auto">
      <li  class="nav-item" >
    
        <div >
          <img src="./assets/dist/img/titulo_andrea.png"  width="150" height="35"  />
         </div>
   
      
      </li>  

    </ul>

    <ul    class="navbar-nav ml-auto">

      



      <li  class="nav-item dropdown" *ngIf="tieneSession == true" >

        <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
     

            <img src="./assets/dist/img/user.png"  width="auto" height="42px" style="margin-top: -16px;margin-right: -12px;"  />

     
          
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <!-- Message Start -->
            <div class="media">
            
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  {{nombreCuenta}}
                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item" (click)="logout()">
            <!-- Message Start -->
            <div class="media">
             
              <div class="media-body">
                <h3 class="dropdown-item-title">
                Cerrar sesión
                  <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                </h3>
                
              </div>
            </div>
            <!-- Message End -->
          </a>
         
         
          
        </div>

      </li>

      <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;margin-top: -8px;">
        <a href="#/carrito">
        <img src="./assets/dist/img/carro.png"  width="auto" height="46"   />
        </a>
      </li>

      <span style="color: rgb(50, 50, 50);font-size: 35px;font-weight:bold">{{CantidadItem}}</span>
  

        <!-- <a  href="#/carrito">
          <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
        
        </a> -->
      
    


  <!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
  {{countpedido}}   
   
</a> -->




     


     


    </ul>
   

  




  </nav>


  
  <!-- /.navbar -->

  <app-sidebar-ecomerce></app-sidebar-ecomerce>
  <!-- /.navbar -->

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
   
    <!-- /.content-header -->

  

     <!-- <div #myModal class="modal fade" id="modal-default">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="overlay-wrapper " *ngIf="esperar == true">
              <div  class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i>
                <div class="text-bold pt-2">Cargando...</div>
              </div>
            </div>


            <div  *ngIf="respuestModal == false">

            <div class="modal-header"  *ngIf="modoPedido == 0">
              <h4 class="modal-title">¡Tu pedido ha sido recibido!</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-header"  *ngIf="modoPedido == 1">
              <h4 class="modal-title">¡Tu Cambio ha sido recibido!</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p style="text-align: center; color: rgb(5, 90, 90);">No. Tickete&hellip;</p>
              <h3 style="text-align: center;">{{numeroPedido}}</h3>
              <p style="text-align: center; color: rgb(5, 90, 90);">No. Voucher de Pago:&hellip;</p>
              <h3 style="text-align: center;">{{authResponseDTO}}</h3>
            </div>
            <div class="modal-footer justify-content-center">
              
              <button type="button" class="btn btn-primary" (click)="IraInicio()">Continuar</button>
            </div>
         
      
          </div>

         
          </div>
        
        </div>
      
      </div> -->
    

  


     
      <div  #myModal class="modal fade" data-backdrop="static" data-keyboard="false" id="modal-sm">
        <div class="modal-dialog" >
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">www.andreagt.com</h4>
            </div>

            <div class="overlay-wrapper " *ngIf="esperar == true">
              <div  class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i>
                <div class="text-bold pt-2">Cargando</div>
              </div>
            </div>
            
            
            <div  *ngIf="respuestaModal == true">
            <div class="modal-body">
              <blockquote class="quote-info" style="text-align: center;">
              <h5 id="note">¡Gracias por tu compra, tu pedido ha sido recibido!</h5>
              <p>{{mensajeForm}}</p>

              <h5 style="color: black;">No. Pedido</h5>
              <h5 style="color: black; font-size: 28px;">{{numeroPedido}}</h5>

              </blockquote>
            </div>
          </div>

          <div  *ngIf="confirmarCambio == true">
            <div class="modal-body">
              <blockquote class="quote-info" style="text-align: center;">
              <h5 id="note">¡Cambio Registrado!</h5>
              <p>{{mensajeForm}}</p>

             

              </blockquote>
            </div>
          </div>

          <div  *ngIf="respuestaModalTarjeta == true">

            <div class="modal-body" style="text-align: center;">
              <img src="./assets/dist/img/neonet.jpg" width="25%"   style="opacity: .9"> 
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{nombreEmpresaDTO}}</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">{{direccionEmpresaDTO}}</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">AF. {{afiliacionNeoNetDTO}}</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">Guatemala C.A.  {{dateLocalTransDTO  | date:'dd/MM/yyyy'}}  {{timeLocalTransDTO}}    No.{{sysTraceNo}}</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">REF {{retrievalResponseDTO}} AUT {{authResponseDTO}}</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">No. TARJETA {{noTarjetaDTO}} EXP: XX/XX</h6>
              <h6 style="color: black; font-size: 12PX; font-family:'Courier New', Courier, monospace">NOMBRE TARJETA {{nombreTarjetaDTO}}</h6>
              <br>
              <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">COMPRA: <strong>  {{granTotalDTO | currency: 'Q'}}</strong></p> 
              <br>
              <div  *ngIf="cuotaDTO != '00' ">
                <p  style="color: black; font-size: 18PX; font-family:'Courier New', Courier, monospace">CUOTAS: <strong>  {{cuotaDTO}}</strong></p> 
                <br>

              </div>
              
              <h6 style="color: black; font-size: 14PX; font-family:'Courier New', Courier, monospace">(01) PAGADO ELECTRONICAMENTE !!</h6>
            </div>

          </div>

          <div  *ngIf="esperar == true">

            <div class="modal-body" style="text-align: center;">
             
              <br>
              <br>
              <br>
              <br>
              <img src="./assets/dist/img/logo_andrea.png" width="50%"   style="opacity: .9">
              <br>
             
              <br>
              <br>
              <br>
              <br>
             
            </div>

          </div>

            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-info" (click)="OnContinuar()" >Continuar</button>
            
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>









      <div #myModal2 class="modal fade" id="modal-default">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header"  *ngIf="modoPedido == 0">
              <h4 class="modal-title">¡LO LAMENTAMOS! <br>  Tu pedido contiene productos que ya no están disponibles !</h4><br>
             
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
           
            <div class="modal-body">
             
              <table class="table table-bordered">
                <thead>
                  <tr >
                    
                    <th>Modelo</th>
                    <th ></th>
                 
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dato of resultadoVerificacion; let i=index" >
                   
                    <td>{{dato.modelo}}</td>
                    <td  style="text-align: left;"> <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="" style="height: 90px;width:auto;"></td>
                   
                  </tr>
                  
                 
                </tbody>
              </table>



            </div>
            <div class="modal-footer justify-content-center">
              
              <button type="button" class="btn btn-primary" (click)="CerrarModal2()">Cerrar</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->



      <div  #myModalError class="modal fade" id="modal-sm">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">www.andreagt.com</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <blockquote class="quote-danger">
              <h5 id="note">Note!</h5>
              <p>{{mensajeForm}}</p>
              </blockquote>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
            
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>


    <!-- Main content -->
    <div class="content">
      <div class="container">





<br>



        <div class="row"  >
          <div class="col-sm-10">

            <div class="card card-success">
          
              <div class="centerdiv">
             
                  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" >
                    <ol class="carousel-indicators" >
                      <br>
                      <br>
                      <br>
                      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active" ></li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                     
                    </ol>
                    <div class="carousel-inner">
                      <div class="carousel-item active" >
                        <div > <img  class="center" src="./assets/dist/img/carrusel1.jpg" width="120%" height="50%"   class="img-fluid"> </div>   
                        
                      </div>
                      <div class="carousel-item" >
                         <img  class="center" src="./assets/dist/img/carrusel2.jpg" width="120%" height="50%"  class="img-fluid"> 
                      </div>
                      <div class="carousel-item">
                         <img  class="center" src="./assets/dist/img/carrusel3.jpg" class="img-fluid" width="120%" height="50%"  > 
                      </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" style="width: 48px;">
                      <span class="carousel-control-custom-icon" aria-hidden="true">
                        <i class="fas fa-chevron-left" style="font-size:20px;"></i>
                      </span>
                    
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" style="width: 48px;">
                      <span class="carousel-control-custom-icon" aria-hidden="true">
                        <i class="fas fa-chevron-right" style="font-size:20px;"></i>
                      </span>
                    
                    </a>
                  </div>
      
                
      
      
               
              </div>
         
      
           
            </div>   
            
          </div>

        </div>



        <div class="row"  *ngIf="modoBusqueda== false">
            <div class="col-sm-10">
              <form [formGroup]="formCarrito" >

              <div class="card card-warning">
                <div class="card-header">
                  <h2 class="card-title" style="font-size: 20px; font-style:italic;">1. Lista de productos </h2>
                </div>
                <!-- /.card-header -->
                <div class="card-body">

                  <div class="card-body table-responsive p-0">
                                 
                                 
                    <div class="card-body pt-0" *ngFor="let dato of pedidoTemp; let i=index">
                      <div class="row">
                        <div class="col-7">
                          <h2 class="lead" style="color:rgb(39, 38, 38);"><b></b></h2>
                          <table class="table">
                            <tr >
                              <td class="text-muted text-lg"> {{dato.modelo}}</td>
                              
                            </tr>
                            <tr>
                             
                              <td class="text-muted text-lg">{{dato.talla}}</td>
                            </tr>
    
                            <tr>
                             
                              <td class="text-muted text-lg">{{dato.colorErp}} </td>
                            </tr>
    

                            <tr *ngIf="hayDescuentoPrecio == true">
                              
                              <td class="text-muted text-lg" style="text-align: left;"><del style="font-size:medium;">{{dato.precio | currency: 'Q'}}</del></td>
                            </tr>

                            <tr>
                              
                              <td class="text-muted text-lg" style="text-align: left;">{{dato.precioFinal | currency: 'Q'}}</td>
                            </tr>

                            <tr>
                              <div style="border-color: white;" *ngIf="dato.tipoDespacho == '1'">
                              <td  class="text-success" style="font-size: 18px;"><b>{{dato.msgDisponibilidad}} </b></td>
                            </div>

                            <div style="border-color: white;" *ngIf="dato.tipoDespacho == '2'">
                              <td  class="text-primary" style="font-size: 18px;"><b>{{dato.msgDisponibilidad}} </b></td>
                            </div>

                            <div style="border-color: white;" *ngIf="dato.tipoDespacho == '0'">
                              <td  class="text-danger" style="font-size: 18px;"><b>{{dato.msgDisponibilidad}}</b></td>
                            </div>

                            </tr>
    
    
                          </table>
    
                        </div>
                        <div class="col-5 text-center">
                          <img src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}} alt="user-avatar" class="img-circle img-fluid" style="height: auto;width: 100%;" >
                        </div>
                        <div class="text-center">
                          <a class="btn btn-md btn-danger" (click)="EliminarDeCarrito(dato.id)" style="height: 44px; width: auto;font-size: large;">
                            <i ></i> Eliminar
                          </a>
                        </div>


                      </div>
                      
                   
                    </div>

                    <div class="table-responsive">
                                <table class="table">
                                   
                                  <!-- <tr>
                                    <th></th>
                                     <td>{{descuentoDTO | currency: 'Q'}}</td> 
                                  </tr>  -->
                                  <tr>
                                    <th style="width:100%;font-size: x-large;" >Total:</th>
                                    <td style="font-size: 25px;">{{granTotalDTO | currency: 'Q'}}</td>
                                  </tr>
                                  
                                </table>
                              
                        </div> 
                        <div *ngIf="errorForm[6] == '1'">
                          <label for="label1"><code>Debe seleccionar algún artículo.</code></label>
                        </div>

                  </div>

               </div>





               <div class="card-body"  *ngIf="SIExistenCodigoDescuento == true">

             

                  <label style="color: #000000">Código Descuento:</label>
                  <div class="input-group mb-2"  >


                    <table class="table table-bordered" style="width: 75%;">
                      <thead>
                        <tr  >
                        
                          <th style="width:auto"><input type="text" class="form-control" style="font-size: larger;font-weight: bold;height: 44px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;" placeholder="" formControlName="txtCodigoDescuento" autocomplete="off"></th>
                          
                           <th style="width: auto"> <button type="button" class="btn btn-block btn-info btn-sm" style="font-size: 24px;" (click)="OnGetCodigoDescuento()">Aplicar</button></th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        
                        
                      </tbody>
                    </table>
                   
                  </div>

                  <div *ngIf="noExisteCodigoDescuento == true">
                    <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Esté código descuento NO EXISTE.</code></label>
                  </div>
       
                </div>





              </div>
            

              <div class="card card-warning">
                <div class="card-header">
                  <h3 class="card-title"  style="font-size: 20px; font-style:italic;">2. Datos para envío</h3>
                </div>
                <!-- /.card-header -->
                <div class="card-body">
                  <div class="form-group">
                    <label style="color: #005475">Departamento</label>
                    <select class="form-control" #mycmbDepto formControlName="cmbDepto" style="background-color: #ffffff;font-weight: bold;height: 48px;color: #000000;border-color: #424242;border-style: solid;border-width: 1.8px;" (change)="onGetMuni()" >
                      
                      <option *ngFor="let dato of depto; let i=index" value={{dato.idDepto}}>{{dato.descripcion}}</option>
                    </select>
                  </div>
                  <div *ngIf="errorForm[0] == '1'">
                    <label for="label1" ><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Seleccione un departamento en donde necesita recibir.</code></label>
                  </div>
                  
                  <div class="form-group">
                    <label style="color: #005475">Municipio</label>
                    <select class="form-control" formControlName="cmbMuni"  style="font-weight: bold;height: 48px;color: #000000;background-color:  #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;">
                      
                      <option *ngFor="let dato of muni; let i=index" value={{dato.idMuni}}>{{dato.descripcion}}</option>
                    </select>
                  </div>
                  <div *ngIf="errorForm[1] == '1'">
                    <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;width: 48px;">Seleccione municipio de entrega.</code></label>
                  </div>
                  
                  
                  
                  <div class="form-group">
                    <label for="lblRecibe" style="color: #005475">¿Quién Recibe?:</label>
                    <input type="text" class="form-control" style="font-size: larger;font-weight: bold;height: 48px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;" placeholder="" formControlName="txtRecibe" autocomplete="off">
                  
                    <div *ngIf="errorForm[2] == '1'">
                      <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba nombre del la persona que recibe.</code></label>
                    </div>
                  </div>



                  <div class="form-group">
                    <label for="lblDireccion" style="color: #005475">Dirección de entrega:</label>
                    <input type="text" class="form-control" class="form-control" style="font-size: larger;font-weight: bold;height: 48px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;" placeholder="" formControlName="txtDireccion" autocomplete="off">
                    <div *ngIf="errorForm[3] == '1'">
                      <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba alguna dirección.</code></label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="lblDireccion" style="color: #005475"> Teléfono de Contacto:</label>
                    <input type="text" mask='0000-0000' class="form-control" class="form-control" style="font-size: larger;font-weight: bold;height: 48px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;"  placeholder="" formControlName="txtTelefono" autocomplete="off" inputmode="numeric">
                  </div>
                  <div *ngIf="errorForm[4] == '1'">
                    <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif; ">Indique por favor un número de contacto.</code></label>
                  </div>



                  
                  <div class="form-group" *ngIf="modoPedido == 1">
                    <label for="lblRecibe" style="color: #005475">Motivo del cambio:</label>
                    <textarea class="form-control" class="form-control" style="font-size: larger;font-weight: bold;color: #000000;background-color:  #FDFDFD" rows="3" placeholder="" formControlName="txtMotivo" autocomplete="off"></textarea>
      
                  </div>

                  <div *ngIf="errorForm[5] == '1'">
                    <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Indique un motivo por favor.</code></label>
                  </div>

                </div>
           
              </div>



              <div class="card card-warning"  *ngIf="activaPago == 1" >
                <div class="card-header">
                  <h3 class="card-title"  style="font-size: 20px; font-style:italic;height: 48px;">3. Forma de Pago</h3>
                </div>
                <!-- /.card-header -->
                <div class="card-body">
                  <div class="form-group">
                    <label for="lblDireccion">Seleccione una opción de pago.</label>
                    <select class="custom-select form-control-border" formControlName="cmbFormaPago"  style="font-size:x-large; height: auto;font-weight: bold;height: 48px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;" (change)="OnHabilitarFormaPago()">
                      <option value="1">Pago con Tarjeta</option>
                      <option value="2">Pago con Tarjeta (Cuotas)</option>
                      <option value="3">Pago Contra-Entrega</option>
                     
                    </select>

                 </div>


                 <div class="form-group" *ngIf="idFormaPago == 2">
                  <label for="lblDireccion">Seleccione No. Cuota.</label>
                  <select class="custom-select form-control-border" formControlName="cmbCuotas"  style="font-size:x-large; height: auto;font-weight: bold;height: 48px;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;">
                    <option value="00">00</option>
                    <option value="02">02</option>
                    <option value="03">03 </option>
                    <option value="06">06</option>
                    <option value="10">10 </option>
                    <option value="12">12</option>
                    <option value="18">18 </option>

                  </select>

               </div>


                <div class="form-group">

                  <div  *ngIf="idFormaPago ==1 || idFormaPago ==2">
                    <div class="col-6">
                    
                      <img src="./assets/dist/img/credit/visa.png" alt="Visa">
                      <img src="./assets/dist/img/credit/mastercard.png" alt="Mastercard">
                    </div>
                    <br>


                  <label for="lblDireccion" style="color: #005475">Numero Tarjeta:</label>
                  <input type="text" class="form-control" class="form-control" style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px;" #mytxtTarjeta mask="0000 0000 0000 0000"  placeholder="" formControlName="txtTarjeta" inputmode="numeric"  >
                </div>
                <div *ngIf="errorForm2[0] == '1'">
                  <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba un número de tarjeta.</code></label>
                </div>

                <div *ngIf="tarjetaInvalida== true">
                  <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">La tarjeta NO ES VÁLIDA.</code></label>
                </div>
              </div>


              <div class="form-group">

                <div  *ngIf="idFormaPago ==1 || idFormaPago ==2">
                  
                  <br>


                <label for="lblDireccion" style="color: #005475">Nombre de la Tarjeta:</label>
                <input type="text" class="form-control" class="form-control" style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px" #mytxtTarjeta mask=""  placeholder="" formControlName="txtNombreTarjeta"   >
              </div>
              <div *ngIf="errorForm2[7] == '1'">
                <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba el nombre de la tarjeta.</code></label>
              </div>
            </div>





              <div *ngIf="idFormaPago ==1 || idFormaPago ==2">
                


                <div class="form-group">
                  <label style="color: #005475">Vencimiento Tarjeta</label>

                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                    </div>
                    <input #input type="text"  mask='00/00'  class="form-control" class="form-control" style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px"  formControlName="txtVencimiento" placeholder="MES/AÑO" inputmode="numeric"  >



                  </div>
                  <!-- /.input group -->
                </div>


                <div *ngIf="errorForm2[1] == '1'">
                  <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba el vencimiento de la tarjeta.</code></label>
                </div>

                <div *ngIf="fechaTarjetaInvalida == true">
                  <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Vencimiento NO VÁLIDO.</code></label>
                </div>
              </div>

              <div  *ngIf="idFormaPago ==1 || idFormaPago ==2">
                <div class="form-group">
               
                  <label for="lblDireccion" style="color: #005475">Código Seguridad:</label>
                  <input type="text" class="form-control"  style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;-webkit-text-security: square;height: 48px" mask="000"  placeholder="" formControlName="txtCodigoSeguridad" inputmode="numeric">
                </div>
                <div *ngIf="errorForm2[2] == '1'">
                  <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba código de seguridad.</code></label>
                </div>
              </div>

                <div class="form-group">
                  <div >
                  
                </div>
                  <br>
                  <div class="col-12">
                    <p class="lead">Facturación:</p>
                    
                    <div class="form-group">
                  

                      <label for="lblNit" style="color: #005475">Nit del constribuyente o CF:</label>
                      <input type="text" class="form-control"  style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px;"  placeholder="" formControlName="txtNit" autocomplete="off" maxlength="15" >
                      <div *ngIf="errorForm2[3] == '1'">
                        <label for="label1"><code  style="font-family:Verdana, Geneva, Tahoma, sans-serif;" >Escriba un Nit.</code></label>
                      </div>
                    </div>

                    <div class="form-group">
                  

                      <label for="lblNombre" style="color: #005475">Nombre del contribuyente :</label>
                      <input type="text" class="form-control"  style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px"  placeholder="" formControlName="txtNombreContribuyente" autocomplete="off">
                      <div *ngIf="errorForm2[4] == '1'">
                        <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba un nombre de contribuyente.</code></label>
                      </div>
                    </div>

                    <div class="form-group">
                  

                      <label for="lblDireccion" style="color: #005475">Dirección del comprador :</label>
                      <input type="text" class="form-control"   style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px" placeholder=" " formControlName="txtDireccionContribuyente" autocomplete="off">
                      <div *ngIf="errorForm2[5] == '1'">
                        <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Escriba una dirección.</code></label>
                      </div>
                    </div>


                    <div class="form-group">
                  

                      <label for="lblTelFactura" style="color: #005475">WhatsApp para recibir factura :</label>
                      <input type="text" mask='0000-0000' class="form-control"  style="font-size: larger;color: #000000;background-color: #ffffff;border-color: #424242;border-style: solid;border-width: 1.8px;font-weight: bold;height: 48px"  placeholder="" formControlName="txtTelFactura" autocomplete="off" inputmode="numeric">
                      <div *ngIf="errorForm2[6] == '1'">
                        <label for="label1"><code style="font-family:Verdana, Geneva, Tahoma, sans-serif;">Ingrese un número de Teléfono para recibir la Factura</code></label>
                      </div>
                    </div>


                  </div>
                </div>
                </div>
              </div>




            </form>
            </div>
     


  <div class="col-sm-10"    >

    <div class="card card-success">
        <div class="card-header">
          <h3 class="card-title" style="color: black;font-size: 25px;">Resumen</h3>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <form>
            <div class="row">
                <div class="col-10 col-sm-12">

                    <div class="table-responsive">
                        <table class="table">
                           <tr>
                            <th style="width:100%; font-size: larger;">Subtotal</th>
                            <td  style="font-size: 25px;">{{totalDTO | currency: 'Q'}}</td> 
                          </tr>
                          <!-- <tr>
                            <th></th>
                             <td>{{descuentoDTO | currency: 'Q'}}</td> 
                          </tr>  -->
                          <tr>
                            <th style="width:100% ; font-size: larger;">Total:</th>
                            <td style="font-size: 25px;">{{granTotalDTO | currency: 'Q'}}</td>
                          </tr>
                          
                        </table>
                      </div>
                </div> 

                <div class="input-group mb-3"  *ngIf="modoPedido == 0">

                  <button type="button" class="btn btn-block btn-warning btn-lg" style="font-size: 28px;" (click)="GenerarPedido()">Comprar</button>
                 
                </div>

                   

                <div class="input-group mb-3"  *ngIf="modoPedido == 1">
                  <!-- <div *ngIf="esperar == true" class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i><div class="text-bold pt-2">Cargando...</div></div> -->
                    <button type="button" class="btn btn-block btn-warning btn-lg" style="font-size: 28px;" (click)="GenerarCambio()">Genenar cambio</button>
                </div> 
                
                <div class="input-group mb-3"  *ngIf="modoPedido == 0">
                    <button type="button" class="btn btn-block btn-info btn-lg" style="font-size: 28px;" (click)="IraInicio()">Agregar otro producto</button>
                </div> 

                <div class="input-group mb-3"  *ngIf="modoPedido == 1">
                  <button type="button" class="btn btn-block btn-info btn-lg" style="font-size: 28px;" (click)="irAtras()">Regresar</button>
              </div> 

                <!-- <div class="input-group mb-3">
                    <button type="button" class="btn btn-block btn-secondary btn-lg" (click)="BorrarTodo()">Borrar todo</button>
                </div>  -->
               
            </div> 
          </form>
          </div>
    </div>
</div>
</div>


<div class="row" *ngIf="modoBusqueda== true">
  <div class="col-sm-10"    >

    <div class="card card-warning">
        <div class="card-header">
          <h3 class="card-title">Resultado búsqueda</h3>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
         
            <div class="row"  infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()">



              <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos of content; let i=index" >
                <div class="row"  (click)="OnSelectProducto02(datos.idProducto)">
                  <div class="text-center">
                   
                    <img class="img-fluid"
                         src={{urlServerUploadArticulos$}}{{datos.imagen}}{{tipoMedia2$}}
                         alt="User profile picture" style="height: 110%;width: 110%;">
                  </div>
                  <div class="col-8">
                    <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                    <label class="text-muted text-sm">{{datos.descripcion}}</label>
                  
                   
                  </div>
                  <div class="col-8" >
                    <p class="text-muted " style="font-size: 16px;color: rgb(30, 30, 30);"><b>{{datos.precio | currency: 'Q'}}</b> </p>
                 </div>

                </div>
              </div>




            </div>
          </div>
        </div>
      </div>
</div>

        <!-- <div class="row" *ngIf="modoBusqueda== true">
          <div class="col-sm-10">
          <div class="card-body">
            <div class="row">
          <div class="col-6 col-sm-6 col-md-4 align-items-stretch " *ngFor="let datos of content; let i=index" >
            <div class="row"  (click)="OnSelectProducto02(datos.idProducto)">
              <div class="text-center">
               
                <img class="img-fluid"
                     src={{urlServerUploadArticulos$}}{{datos.imagen}}{{tipoMedia2$}}
                     alt="User profile picture" style="height: 110%;width: 110%;">
              </div>
              <div class="col-8">
                <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                <label class="text-muted text-sm">{{datos.descripcion}}</label>
                <p class="text-muted text-sm"><b>Precio: </b> {{datos.precio | currency: 'Q'}}</p>
               
              </div>
              <div class="col-8" >
             </div>
            </div>
        </div>
        </div>
        </div>
        </div>
      </div> -->



        <!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <div class="content">
      <div class="container">
        <div class="row">

         
              
          <div class="col-10">

          <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
        </div>
   
</div>
      </div>
    </div>
      
    <div class="IconoWhatsApp">
      <a
      href="https://wa.me/+50243185405?text=mensaje"
      target="_blank">
      <img id="appear"
        class="whatsapp"
        src="./assets/dist/img/whatsapp.png"
        alt="IconoWhatsApp"
      />
    </a>
  </div>
   
  </div>
  <!-- /.content-wrapper -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->

  </aside>
  <!-- /.control-sidebar -->


 

</div>
  <!-- Main Footer -->


  
<app-footer-ecomerce ></app-footer-ecomerce>



</html>
